import { SlicePipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ShowMoreAction } from '../../model/tabs';
import {
  SearchParamsContainerComponent
} from '../../search-params/search-params-container/search-params-container.component';
import {
  SearchResultWrapperComponent
} from '../../search-result/search-result-wrapper/search-result-wrapper.component';
import { TabResultSection } from '../tab.service';

@Component({
  selector: 'app-tab-section',
  templateUrl: './tab-section.component.html',
  styleUrls: [ './tab-section.component.scss' ],
  imports: [ SearchResultWrapperComponent, SlicePipe ]
})
export class TabSectionComponent {
  @Input() section: TabResultSection;
  ShowMoreAction = ShowMoreAction;
  showMore = false;
  paramsContainer = inject(SearchParamsContainerComponent);

  get resultsShown() {
    return this.section.config?.showMoreAction === ShowMoreAction.EXPAND && !this.showMore
      ? this.section.initialCount
      : this.section.results?.length;
  }

  toggle() {
    this.showMore = !this.showMore;
    this.section.visibleCount = this.resultsShown;
  }

}
